module.exports = __webpack_public_path__ + "img/bg_black_border.1a518ebd.png";